// extracted by mini-css-extract-plugin
export default {"container":"main-dish_container__Cst3a","buttons":"main-dish_buttons__3OTvD","title":"main-dish_title__xydIk"};